import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AddCreditCardIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 32 16" title={t`Add Credit Card`} {...props}>
    <Rect width="32" height="16" fill="none" />
    <Path
      d="M23 8V5C23 3.89543 22.1046 3 21 3H11C9.89543 3 9 3.89543 9 5V11C9 12.1046 9.89543 13 11 13H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <Path
      d="M18 12L22 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <Path
      d="M20 14L20 10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <Path d="M9 6.5H23" stroke="currentColor" strokeWidth="1.5" fill="none" />
  </Icon>
);
